import { useEffect, useState } from "react";
import client from "../api_v2/client";

export function useAutocompleteSuggestions(body: string, userId?: number) {
  const [allTags, setAllTags] = useState<string[]>([]);
  const [allTitles, setAllTitles] = useState<string[]>([]);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [trigger, setTrigger] = useState<"#" | "@" | null>(null);

  useEffect(() => {
    if (!userId) {
      console.warn("❌ userId не передан");
      return;
    }

    client
      .get("/ruznama/get_tags.php", { params: { user_id: userId } })
      .then(({ data }) => data.success && setAllTags(data.result))
      .catch(console.error);

    client
      .get("/ruznama/get_titles.php", { params: { user_id: userId } })
      .then(({ data }) => data.success && setAllTitles(data.result))
      .catch(console.error);
  }, [userId]);

  useEffect(() => {
    const tagMatch = body.match(/(^|\s)#([\p{L}\p{N}_]{0,20})$/u);
    const mentionMatch = body.match(/(^|\s)@([\p{L}\p{N}_ ]{0,40})$/u);

    if (tagMatch) {
      const typed = tagMatch[2].toLowerCase();
      const filtered = typed
        ? allTags.filter((t) => t.toLowerCase().startsWith(typed))
        : allTags;
      setSuggestions(filtered);
      setTrigger("#");
    } else if (mentionMatch) {
      const typed = mentionMatch[2].toLowerCase();
      const filtered = typed
        ? allTitles.filter((t) => t.toLowerCase().startsWith(typed))
        : allTitles;
      setSuggestions(filtered);
      setTrigger("@");
    } else {
      setSuggestions([]);
      setTrigger(null);
    }
  }, [body, allTags, allTitles]);

  return { suggestions, trigger };
}
